import DownloadsTemplate from "./DownloadsTemplate";

export default function Regulations() {
  const files = [
    {
      titleKey: "governance.regulations.files.1.title",
      descKey: "governance.regulations.files.1.desc",
      url: "#"
    }
  ];

  return (
    <DownloadsTemplate
      titleKey="governance.regulations.title"
      descriptionKey="governance.regulations.description"
      files={files}
      seoTitleKey="governance.regulations.seo.title"
      seoDescKey="governance.regulations.seo.description"
      seoPath="/governance/regulations"
    />
  );
}